<script setup>
import { Head } from '@inertiajs/vue3';
import Button from '@/Components/Button.vue';

const props = defineProps({
    status: Number
})

const statusMessages = {
    404: {
        title: 'Pagina niet gevonden',
        message: 'De pagina die je zoekt bestaat niet of is verplaatst.'
    },
    403: {
        title: 'Toegang geweigerd',
        message: 'Je hebt geen toegang tot deze pagina.'
    },
    500: {
        title: 'Interne serverfout',
        message: 'Er is een fout opgetreden op de server. Probeer het later opnieuw.'
    },
    default: {
        title: 'Onbekende fout',
        message: 'Er is een onbekende fout opgetreden.'
    }
}

</script>

<template>
    <section class="flex justify-center items-center pt-24">
        <div class="max-w-lg text-center">
            <p class="text-2xl font-semibold leading-8 text-green-800">{{ props.status }}</p>
            <h1 class="mt-4 text-3xl font-bold tracking-tight text-zinc-900 sm:text-5xl">{{
                statusMessages[props.status].title }}</h1>
            <p class="mt-6 text-base leading-7 text-zinc-600">{{ statusMessages[props.status].message }}</p>
            <div class="mt-10">
                <Button href="/" variant="white" icon="arrow-left" iconPosition="left" size="small" class="text-green-800 hover:text-green-800/80">Terug naar Hoofdpagina</Button>
            </div>
        </div>
    </section>
</template>